angular.module('rjmNg.services').factory 'referenceService', [
  () ->

    # Returns the reference that this column is using
    find : (references, column) ->
      toId = column.properties.joins[0].local_column_ids[0]
      referenceList = []
      for reference in references
        if toId is reference.to.column or toId is reference.from.column
          referenceList.push(reference)
      return referenceList

    # Use the column definition to validate usable references
    filter : (references, localTableId, field, validateFunction) ->
      (reference for reference in references when validateFunction(localTableId, field, reference))
]
